/*
    Production: https://sharedopsapi.vercel.app/api
    Development: http://localhost:4000/api
*/
export const config = {
  api: "https://sharedopsapi.vercel.app/api",
};
